/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_TeamInputs */

const th_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดข้อมูลทีม…`)
};

const en_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading team…`)
};

const ja_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームを読み込んでいます…`)
};

const zh_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载球队…`)
};

const es_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando equipo…`)
};

const pt_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando time…`)
};

const id_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat tim…`)
};

const fr_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de l’équipe…`)
};

const tl_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilo-load ang team…`)
};

const vi_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải đội…`)
};

const ko_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀을 불러오는 중…`)
};

const de_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team wird geladen…`)
};

const ru_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загружаем команду…`)
};

const tr_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takım yükleniyor…`)
};

const it_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento squadra…`)
};

const pl_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie drużyny…`)
};

const uk_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажуємо команду…`)
};

const hi_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम लोड हो रही है…`)
};

const ar_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل الفريق…`)
};

const ms_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat pasukan…`)
};

const bn_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল লোড হচ্ছে…`)
};

const zh_tw2_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入球隊…`)
};

const zh_hk2_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入球隊…`)
};

const ur_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیم لوڈ ہو رہی ہے…`)
};

const fa_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال بارگذاری تیم…`)
};

const sw_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia timu…`)
};

const nl_loading_team = /** @type {(inputs: Loading_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team laden…`)
};

/**
* | output |
* | --- |
* | "Loading team…" |
*
* @param {Loading_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_team = /** @type {((inputs?: Loading_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_loading_team(inputs)
	if (locale === "ja") return ja_loading_team(inputs)
	if (locale === "zh") return zh_loading_team(inputs)
	if (locale === "es") return es_loading_team(inputs)
	if (locale === "pt") return pt_loading_team(inputs)
	if (locale === "id") return id_loading_team(inputs)
	if (locale === "fr") return fr_loading_team(inputs)
	if (locale === "tl") return tl_loading_team(inputs)
	if (locale === "vi") return vi_loading_team(inputs)
	if (locale === "ko") return ko_loading_team(inputs)
	if (locale === "de") return de_loading_team(inputs)
	if (locale === "ru") return ru_loading_team(inputs)
	if (locale === "tr") return tr_loading_team(inputs)
	if (locale === "it") return it_loading_team(inputs)
	if (locale === "pl") return pl_loading_team(inputs)
	if (locale === "uk") return uk_loading_team(inputs)
	if (locale === "hi") return hi_loading_team(inputs)
	if (locale === "ar") return ar_loading_team(inputs)
	if (locale === "ms") return ms_loading_team(inputs)
	if (locale === "bn") return bn_loading_team(inputs)
	if (locale === "zh-TW") return zh_tw2_loading_team(inputs)
	if (locale === "zh-HK") return zh_hk2_loading_team(inputs)
	if (locale === "ur") return ur_loading_team(inputs)
	if (locale === "fa") return fa_loading_team(inputs)
	if (locale === "sw") return sw_loading_team(inputs)
	if (locale === "nl") return nl_loading_team(inputs)
	return en_loading_team(inputs)
});